<!--<button class="btn btn-info btn_backtohome" (click)="gotoHome()"> {{'Common.BackToHome' |translate}}</button>-->
  <div [className]="'no_Access'">
    <img src="assets/NewJT7/img/access-denied.png" />
    <h1> {{ 'Common.AccessDenied' | translate }}</h1>
    <p> {{ 'Common.AccessDeniedMsg' | translate }}</p>
  </div>


